"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MyOauthReceiver = exports.MyOauthSender = void 0;

var _react = _interopRequireWildcard(require("react"));

var _queryString = _interopRequireDefault(require("query-string"));

var _axios = _interopRequireDefault(require("axios"));

var _buffer = require("buffer");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MyOauthSender = function MyOauthSender(props) {
  var baseUrl = process.env.REACT_APP_AUTHORIZE_URL;
  var args = {
    client_id: process.env.REACT_APP_CLIENT_ID,
    response_type: "code",
    scope: process.env.REACT_APP_SCOPE,
    redirect_uri: process.env.REACT_APP_REDIRECT_URI
  };

  var url = _queryString.default.stringifyUrl({
    url: baseUrl,
    query: args
  });

  return props.render({
    url: url
  });
};

exports.MyOauthSender = MyOauthSender;

var MyOauthReceiver = function MyOauthReceiver(_ref) {
  var handleSuccess = _ref.handleSuccess,
      handleError = _ref.handleError;

  var parsed = _queryString.default.parse(window.location.search);

  var args = {
    code: parsed.code,
    grant_type: "authorization_code",
    scope: process.env.REACT_APP_SCOPE,
    redirect_uri: process.env.REACT_APP_REDIRECT_URI
  };

  var basicAuthorization = "Basic " + _buffer.Buffer.from(process.env.REACT_APP_CLIENT_ID + ":" + process.env.REACT_APP_CLIENT_SECRET).toString('base64');

  (0, _react.useEffect)(function () {
    _axios.default.post(process.env.REACT_APP_TOKEN_URL, {}, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': basicAuthorization
      },
      params: args
    }).then(function (response) {
      return response.data;
    }).then(function (data) {
      return handleSuccess(data);
    }).catch(function (error) {
      return handleError(error);
    });
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", null, "Authorizing");
};

exports.MyOauthReceiver = MyOauthReceiver;